__turbopack_context__.v({
  "wrapper": "page-module___8aEwW__wrapper",
});
